import { render, staticRenderFns } from "./ProductsGroupCard.Vue?vue&type=template&id=d54ae666"
import script from "./ProductsGroupCard.Vue?vue&type=script&lang=js"
export * from "./ProductsGroupCard.Vue?vue&type=script&lang=js"
import style0 from "./ProductsGroupCard.Vue?vue&type=style&index=0&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/ProductsGroupCard.Vue
// module id = 197
// module chunks = 0